// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { DailyOfficeHoursResponse } from './daily-office-hours-response';

/** See com.rev360.pms.api.controller.schedule.PracticeLocationOfficeHoursResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeLocationOfficeHoursResponse extends GandalfModelBase {

	@GandalfProperty({ designType: DailyOfficeHoursResponse })
	friday!: DailyOfficeHoursResponse | null;

	@GandalfProperty({ designType: DailyOfficeHoursResponse })
	monday!: DailyOfficeHoursResponse | null;

	@GandalfProperty({ designType: DailyOfficeHoursResponse })
	saturday!: DailyOfficeHoursResponse | null;

	@GandalfProperty({ designType: DailyOfficeHoursResponse })
	sunday!: DailyOfficeHoursResponse | null;

	@GandalfProperty({ designType: DailyOfficeHoursResponse })
	thursday!: DailyOfficeHoursResponse | null;

	@GandalfProperty({ designType: DailyOfficeHoursResponse })
	tuesday!: DailyOfficeHoursResponse | null;

	@GandalfProperty({ designType: DailyOfficeHoursResponse })
	wednesday!: DailyOfficeHoursResponse | null;

}
